"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginModalHelper = (function () {
    function LoginModalHelper() {
    }
    LoginModalHelper.bind = function (user) {
        user.username = String($('.user-username').val());
        user.password = String($('.user-password').val());
        return user;
    };
    ;
    LoginModalHelper.clearloginInputs = function () {
        $('.user-username').val('');
        $('.user-password').val('');
        $('.login-error-block').empty();
    };
    ;
    LoginModalHelper.logErorr = function (error) {
        var translation = window['langArr'][this.language];
        if (error === 'Error: Authentication failed') {
            $('.login-error-block').html(translation['auth_failed']);
        }
        else {
            $('.login-error-block').html(error);
        }
    };
    LoginModalHelper.closeModal = function () {
        $('.login-modal').modal('hide');
    };
    LoginModalHelper.language = window['lang'] === null ? 'en' : window['lang'];
    return LoginModalHelper;
}());
exports.default = LoginModalHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/helpers/login-modal-helper.ts
// module id = 376
// module chunks = 5